import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { FLIGHT_PROD_URL } from "../../../constants/constants";
import { ButtonStyles } from "./ButtonStyles";
import { useGeAndLtFromUrl } from "reports/components/Reports/reportUtils";
import { ONE_DAY_OF_MS } from "reports/utils/timeUtils";
import { useParams } from "react-router";
import { ReportParams } from "reports/types";
import { useVisibleGroups } from "utils/customHooks/genericHooks";

/**
 *  Button that links to Flight timeline page
 */
export const FlightTimelineButton = ({
  flightTimelineLinkGroup,
}: {
  flightTimelineLinkGroup: string;
}) => {
  const { ckey: tenant } = useParams() as ReportParams;
  const visibleGroups = useVisibleGroups();
  const { t } = useTranslation("EOSReport");
  const { ge, lt } = useGeAndLtFromUrl();

  const flightGroupData = visibleGroups?.find(
    group =>
      group.summaryGroup.toLowerCase() ===
        flightTimelineLinkGroup?.toLowerCase() ||
      group.shortName.toLowerCase() === flightTimelineLinkGroup?.toLowerCase()
  );

  const flightTimelineGroupFromMachemetry = flightGroupData?.summaryGroup;

  return flightTimelineGroupFromMachemetry ? (
    <a
      href={`${FLIGHT_PROD_URL}/${tenant}/dashboard/${flightTimelineGroupFromMachemetry}?view=tl&ge=${ge}&lt=${lt}`}
      target="_blank"
      rel="noopener noreferrer"
    >
      <Button variant="outlined">
        {t("Check out the timeline on Flight")}
      </Button>
    </a>
  ) : null;
};

/**
 *  Button that links to Flight Trends page for weekly report
 */
export const FlightTrendsButton = () => {
  const { ckey: tenant } = useParams() as ReportParams;
  const { ge } = useGeAndLtFromUrl();

  return (
    <a
      href={`${FLIGHT_PROD_URL}/${tenant}/trends?binSize=days&ge=${ge}&lt=${
        ge + 7 * ONE_DAY_OF_MS
      }`}
      target="_blank"
      rel="noopener noreferrer"
    >
      <Button variant="outlined">Check out trends on Flight</Button>
    </a>
  );
};

export const FlightDashboardButton = ({ href }: { href: string }) => {
  const { t } = useTranslation("EOSReport");

  return (
    <ButtonStyles>
      <a href={href} target="_blank" rel="noopener noreferrer">
        <Button variant="outlined">{t("View on Flight")}</Button>
      </a>
    </ButtonStyles>
  );
};
